import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const { loginWithCode } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const code = new URLSearchParams(location.search).get('code');
    if (!code) {
      navigate('/login', { replace: true });
      return;
    }
    loginWithCode(code)
      .then(() => navigate('/', { replace: true }))
      .catch(() => navigate('/login', { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
